import { render, staticRenderFns } from "./CollectWriteLink.vue?vue&type=template&id=72ac6886&scoped=true&"
import script from "./CollectWriteLink.vue?vue&type=script&lang=js&"
export * from "./CollectWriteLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac6886",
  null
  
)

export default component.exports